module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Forward-5099049a1329d23826fab3826ad5082a.svg";